<template>
    <contentCardMobile :loading="loading" :elevation="0" classCard="px-0 mx-0 py-0" cardColor="transparent">
        <template slot="cardContent">
            <div >
                <!-- <v-row justify="space-around">
                    <v-col cols="12" md="5" >
                        <div class="font-weight-bold body-1 courses-m-read-main-container">
                           {{ course.title }}
                        </div>
                    </v-col>
                </v-row> -->
                 
            
                    

                <v-row justify="space-around">
                    <v-col cols="12" lg="8"  class="py-0">

                        <div class="text-center" v-if="loading">
                            <v-progress-circular
                                indeterminate
                                color="primary"
                            ></v-progress-circular>
                        </div>

                        <div v-if="!loading && course == null" class="text-center">
                            <span>Sin resultados</span>
                        </div>
                        

                        <v-card text="" title="" class="mt-2 mx-0 px-0">
                                    <div class="d-flex  " >
                                        
                                        <!-- sidebar -->
                                        <SideBarProgress
                                        class=""
                                        :key="updateNavCat"
                                        :course="course"
                                        :mobilMode="true"
                                        :appMode="false"
                                        @selectLessonAction="(v) =>{ selectLesson(v.lesson, v.indexSection, v.indexLession)}"
                                        :valueInput="menu"
                                        @valueChange="
                                            (v) => {
                                                menu = v;
                                            }
                                        "
                                        ></SideBarProgress>
                                    
                                        <!-- Body -->
                                            <div :class="{ 'shifted-content': !$vuetify.breakpoint.mdAndDown }" class="courses-progress-h-mobile courses-progress-content-body">
                                            <div>
                                                <v-row justify="center"  class="courses-progress-main-title-row">
                                                <v-col class="text-left col-md-12">
                                                    <div class="font-weight-bold body-1 courses-progress-main-container">
                                                        <div class="courses-icon-side">
                                                            <v-icon @click="menu=!menu" class="">
                                                                mdi-menu
                                                            </v-icon>
                                                        </div>
                                                       
                                                        {{ this.course.title }}
                                                    </div>
                                                </v-col>
                                                
                                            </v-row>
                                            <div v-if="!loadingLesson">
                                                <v-row v-if="courseState == 'INIT'">
                                                    <v-col class="text-center" >
                                                        <p>Selecciona una lección</p>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-if="courseState == 'NO_CONTENT'">
                                                    <v-col class="text-center">
                                                        <p>La lección no tiene contenido</p>
                                                        <secondary-button v-if="deadEnd" :props="returnBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-if="courseState == 'ERROR'">
                                                    <v-col class="text-center">
                                                        <p>Hubo un problema al obtener la lección</p>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                            <v-col align-self="center" cols="12" class="text-center mt-5" v-if="loadingLesson">
                                                <v-progress-circular
                                                    size="100"
                                                    indeterminate
                                                    color="secondary"
                                                ></v-progress-circular>
                                            </v-col>
                                            <v-row v-if="selectedLesson != null && courseState == 'SELECT'" key="richKey" justify="center">
                                                
                                                <v-col v-if="!loadingLesson">
                                                    <RichTextForm
                                                        :readMode="true"
                                                        :valueInput="selectedLesson.content"
                                                        :images_data="[]"
                                                        @valueChange="
                                                            (v) => {
                                                                
                                                            }
                                                        "
                                                        @imagesDataChanged="
                                                            (v) => {
                                                            
                                                            }
                                                        "
                                                    ></RichTextForm>
                                                    
                                                </v-col>
                                            </v-row>
                                            </div>
                                            <v-row justify="center" align="end" v-if="selectedLesson != null && courseState == 'SELECT'">
                                                <v-col cols="12"  class="">
                                                    <v-row justify="end" class="px-3 py-3">
                                                        <primary-button :props="saveBtnData" class=""></primary-button>  
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        
                                    </div>
                        </v-card>
                        

                      
                       
                        
                    </v-col>
                </v-row>
            </div>
        </template>
    </contentCardMobile>
    
</template>

<script>
/* eslint-disable vue/no-unused-components */
// import Utils from '../../../helpers/Utils';
import SideBarProgress from '../../managerViews/courses/read/SideBarProgress.vue';
import RichTextForm from '../../../components/RichTextForm.vue';
export default {
    
    components: {
        SideBarProgress,
        RichTextForm
    },
	data(){
		return {
            menu:false,
            loading:true,
            loadingLesson:false,
            secPass:0,
            richKey: 887,
            id: this.$route.params.id,
            deadEnd:false,
            courseState: "INIT", //BLANK SELECTED NO_CONTENT
            selectedLesson:null,
            idLesson:-1,
            updateNavCat:7373,
            indexSectionSelected: -1,
            indexLessonSelected: -1,
            course:{
                title: "",
                brief_description:"",
                duration: "",
                summary: "",
                description: "",
                what_you_will_learn: "",
                sections:[
                    // {
                    //     title: '',
                    //     lessons: [
                    //         {
                    //             title:'',
                    //             type: 'LECCIÓN',
                    //             has_content:false,
                    //         }
                    //     ]
                    // }
                ],
                list_companies:[],
                draft:0,
                image_file: [],
                update_image_file: [],
                image_url: "",
                sections_to_delete: [],
                lessons_to_delete: [],

                images_data:[
                    // {id, url}
                ]
                // _method: "POST",
            },
            saveBtnData: {
                text: "Siguiente Lección",
                icon: "",	
                click: () => {this.completeLesson()},
                block:false,
                loading: false,
            },
            returnBtnData: {
                text: "Regresar a los cursos",
                icon: "",
                to: "EmployeeCourses",	
                block:false,
                click: () => {},
            },
		}
    },
    watch: {
        
     
      
    },
    mounted(){
        this.index();
    },
	methods: {
        setTime: function(){

            setInterval(() => {
               this.secPass = this.secPass + 1;
            }, 1000)
        },

        index(){
            
            this.loading = true;
            this.$api.employeeCourses.getCourseProgress(this.id)
				.then((response) =>{
                    this.course.title = response.data.title;
                    this.course.brief_description = response.data.brief_description;
                    this.course.duration = response.data.duration;
                    this.course.summary = response.data.summary;
                    this.course.description = response.data.description;
                    this.course.what_you_will_learn = response.data.what_you_will_learn;
                    this.course.sections =response.data.sections;
                    this.course.list_companies = response.data.companies.map((x) => {
                        return {text: x.name, value: x.id}
                    });
                    this.course.draft = response.data.draft == true ? 1 : 0;
                    this.course.image_file = [];
                    this.course.image_url = response.data?.image?.url??'';

                    for (let i = 0; i < this.course.sections.length; i++) {
                        this.course.sections[i]
                        for (let index = 0; index < this.course.sections[i].lessons.length; index++) {
                            this.course.sections[i].lessons[index].type = this.course.sections[i].lessons[index].content_type;
                            // this.course.sections[i].lessons[index].completed = false;
                            this.course.sections[i].lessons[index].selected = false;
                        }
                        
                    }

                    this.selectDefaultLesson(this.course);

					
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
                    this.loading = false;
				})
			;

          
        },

        selectDefaultLesson(course){
            let nextLessonFound = false;
            let firstLesson = null;
            let indS = 0;
            let indL = 0;
            let lessonSelected = null;

            course.sections.forEach((section,indexS) => {
                section.lessons.forEach((lesson, indexL) => {
                lesson.selected = false;

                if (!firstLesson) {
                    firstLesson = lesson;
                }

                if (!nextLessonFound && !lesson.completed && lesson.has_content) {
                    lesson.selected = true; 
                    nextLessonFound = true; 
                    indS = indexS;
                    indL = indexL;
                    lessonSelected = lesson;
                }
                });
            });

            if (!nextLessonFound && firstLesson) {
                firstLesson.selected = true;
                lessonSelected = firstLesson;
            }
            this.selectLesson(lessonSelected, indS, indL);
        },

        completeLesson(){
			//this.$store.state.overlay = true
			this.saveBtnData.loading = true;

            const data = {
                // employee_id: Number(this.$store.state.userData.id),
                time_spent: this.secPass,
                completed: true
            }
           
			this.$api.employeeCourses.saveProgress(this.selectedLesson.id, data)
			.then((response) => {
                console.log(response)
                this.setSectionLessonCompleted(this.indexLessonSelected, this.indexSectionSelected)
                this.setNextLesson();


			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
                this.saveBtnData.loading = false;
			})
		},

        setNextLesson(){
            console.log("next", this.course.sections[this.indexSectionSelected].lessons.length, this.indexLessonSelected)
            if(this.course.sections.length == this.indexSectionSelected +1 && this.course.sections[this.indexSectionSelected].lessons.length == this.indexLessonSelected + 1){
                //fin
                this.$router.push({ name: 'EmployeeCourses', params: { id: this.id }}).catch(()=>{});
                console.log("fin")
                return;
            }
            if(this.course.sections[this.indexSectionSelected].lessons.length == this.indexLessonSelected + 1){
                //next section
                this.indexSectionSelected = this.indexSectionSelected + 1;
                this.indexLessonSelected = 0;
               
            }else{
                this.indexLessonSelected = this.indexLessonSelected + 1;
            }
            console.log("primer if", this.course.sections[this.indexSectionSelected].lessons.length, this.indexLessonSelected)
           
            console.log("ok ?")
            let nextLesson = this.course.sections[this.indexSectionSelected].lessons[this.indexLessonSelected];
            console.log(nextLesson, this.indexLessonSelected, this.indexSectionSelected)
            this.selectLesson(nextLesson, this.indexSectionSelected, this.indexLessonSelected);
        },

        isLast(indexSection, indexLession){
            console.log(this.course.sections.length,indexSection, indexLession )
            if(this.course.sections.length == indexSection +1 && this.course.sections[indexSection].lessons.length == indexLession + 1){
                this.deadEnd = true;
                this.saveBtnData.text = "Finalizar curso";
            }else{
                 this.saveBtnData.text = "Siguiente Lección";
            }
        },

        selectLesson(lesson, indexSection, indexLession){
            this.loadingLesson = true;
            this.$api.employeeCourses
                .getLesson(lesson.id)
                .then((resp) => {
                    // let bodyWithId = JSON.parse(JSON.stringify(lesson));
                    if(resp.data['content'] != null)
                    {
                        resp.data['content'] = {
                            'type': "doc",
                            'content': resp.data['content']
                        }
                        this.selectedLesson = resp.data;
                        this.courseState = 'SELECT'
                    }else{
                        this.courseState = 'NO_CONTENT'
                    }

                    
                    this.secPass = 0;
                    this.setTime();
                    this.isLast(indexSection, indexLession);
                    this.setLessonSelected(indexSection, indexLession)

                        
                    //     let bodyWithUrl = JSON.parse(JSON.stringify(resp.data));

                    //     for (let i = 0; i < bodyWithId.content.content.length; i++) {
                    //         const item = bodyWithId.content.content[i];
                    //         if(item.content != undefined && Array.isArray(item.content)){
                    //             for (let j = 0; j < item?.content?.length; j++) {
                    //                 const element = item?.content[j];
                    //                 if(element.type == 'image'){
                    //                     const id = element.attrs.src;
                    //                     const url = bodyWithUrl.content.content[i].content[j].attrs.src;
                    //                     this.values.images_data.push({id:id, url: url});
                    //                 }
                    //             }
                    //         }
                            
                    //     }
                    // }
                    

                    // console.log(this.values.images_data, "images_data");

                    
                    // // resp.data['content']['type'] = "doc";
                    // // resp.data['content']['content'] = resp.data['content'];
                    // this.values.sections[indexSection].lessons[indexLession] =resp.data;
                    // lesson = this.values.sections[indexSection].lessons[indexLession];
                    // this.showRich = true;
                    this.indexSectionSelected = indexSection;
                    this.indexLessonSelected = indexLession;
                   
                    // this.lessonBackup = resp.data['content'] == null ? lesson : bodyWithId; //JSON.parse(JSON.stringify(lesson));
                    // this.lessonBackup['type'] = this.lessonBackup.content_type;

                    console.log(this.selectedLesson)

                    // this.$emit('showRichChanged', {showRich: this.showRich, idLesson: lesson.id, indexSectionSelected: this.indexSectionSelected, indexLessonSelected: this.indexLessonSelected});
                })
                .catch((error) => {
                    console.log(error, "s");
                    this.courseState = 'ERROR';
                })
                .finally(() => {
                    this.loadingLesson = false;
                })
            ;

        },

        setSectionLessonCompleted(indexLession, indexSection){
            this.course.sections[indexSection].lessons[indexLession].completed = true;
            this.updateNavCat = this.updateNavCat + 1;
        },
        setLessonSelected(indexSection, indexLession){
            for (let i = 0; i < this.course.sections.length; i++) {
                for (let index = 0; index < this.course.sections[i].lessons.length; index++) {
                    this.course.sections[i].lessons[index].selected = false;

                }
                
            }
            this.course.sections[indexSection].lessons[indexLession].selected = true;
            this.updateNavCat = this.updateNavCat + 1;
        },

        
       
    },
}
</script>

<style lang="scss"> 
   
   .courses-progress{
      
        &-h-mobile{
            max-height: calc(100vh - 180px);
        }
    }

    .courses{
        &-icon-side{
            display:none;
            @media (max-width: #{map-get($grid-breakpoints, 'lg')}) {
                display: block;
            }
        }
    }
</style>